import React from 'react';
import { Descriptions, Space, Popover, Typography } from 'antd';
import { LeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import get from 'lodash/get';
import map from 'lodash/map';

const { Text } = Typography;

const MarketingAgencyInfo = (props) => {
  const { onClose, agency } = props;

  return (
    <>
      <div className="heading">
        <LeftOutlined
          className="back-btn"
          onClick={() => {
            onClose();
          }}
        />
        Agency Details
      </div>
      <div className="product-final-confirmation-container mt-30">
        <Descriptions bordered column={1} size="large">
          <Descriptions.Item label="Name">
            {get(agency, 'name')}
          </Descriptions.Item>
          <Descriptions.Item label="Total Brands ">
            {get(agency, 'allocated_brands')}
          </Descriptions.Item>

          <Descriptions.Item label="Total Retailers">
            <Space size="large">
              {get(agency, 'MarketingCompanyPartnerRetailers').length}
              <Popover
                content={
                  <>
                    {map(
                      get(agency, 'MarketingCompanyPartnerRetailers'),
                      (retailer) => (
                        <div key={get(retailer, 'id')}>
                          <Space size="large">
                            <Text type="secondary">
                              {get(retailer, 'PartnerRetailer.name')}
                            </Text>
                          </Space>
                        </div>
                      )
                    )}
                  </>
                }
                title={`Retailers (${
                  get(agency, 'MarketingCompanyPartnerRetailers').length
                })`}
              >
                <InfoCircleOutlined />
              </Popover>
            </Space>
          </Descriptions.Item>

          <Descriptions.Item label="User">
            <Space size="large">
              {get(agency, 'marketing_users_count')}
              <Popover
                content={
                  <>
                    <div>
                      <Space size="large">
                        <Text strong>Admin : </Text>
                        <Text type="secondary">
                          {get(agency, 'marketing_admin_count')}
                        </Text>
                      </Space>
                    </div>
                    <div>
                      <Space size="large">
                        <Text strong>Manager : </Text>
                        <Text type="secondary">
                          {get(agency, 'marketing_manager_count')}
                        </Text>
                      </Space>
                    </div>
                  </>
                }
                title={`Users (${get(agency, 'marketing_users_count')})`}
              >
                <InfoCircleOutlined />
              </Popover>
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};

export default MarketingAgencyInfo;
